
import { Component, Vue } from 'vue-property-decorator';
import AddProjectDialog from './components/projectDialog.vue';

@Component({
  name: 'ProjectAdded',
  components: {
    AddProjectDialog
  }
})
export default class extends Vue {
  private editData: any = {}
  private labelWidth: String = '120px'
}
